export const button = {
  closeCard: document.getElementById('closeCardBtn'),
  closeEmployeeDetails: document.getElementById('closeEmployeeDetailsBtn'),
  closeMenuCard: document.getElementById('closeMenuCardBtn'),
  continueGame: document.getElementById('continue-button'),
  credits: document.getElementById('credits-button'),
  designs: document.getElementById('designsCardBtn'),
  employees: document.getElementById('employeesCardBtn'),
  financesBank: document.getElementById('financesBankBtn'),
  finances: document.getElementById('financesCardBtn'),
  financesLoansTaken: document.getElementById('financesLoansTakenBtn'),
  financesMonths: document.getElementById('financesMonthsBtn'),
  financesYears: document.getElementById('financesYearsBtn'),
  newGame: document.getElementById('new-button'),
  parts: document.getElementById('partsCardBtn'),
  partsDelivery: document.getElementById('partsDeliveryBtn'),
  partsMarket: document.getElementById('partsMarketBtn'),
  settings: document.getElementById('settings-button'),
};

export const div = {
  aircraftDIV: document.getElementById('aircraftDIV'),
  cardContainer: document.getElementById('cardContainer'),
  creditsCard: document.getElementById('creditsCard'),
  designsCard: document.getElementById('designsCard'),
  employeeDetailsContainer: document.getElementById('employeeDetailsContainer'),
  employeesCard: document.getElementById('employeesCard'),
  financesBank: document.getElementById('financesBank'),
  financesCard: document.getElementById('financesCard'),
  financesLoansTaken: document.getElementById('financesLoansTaken'),
  financesMonths: document.getElementById('financesMonths'),
  financesYears: document.getElementById('financesYears'),
  gameContainer: document.getElementById('game'),
  menuCardContainer: document.getElementById('menuCardContainer'),
  menuContainer: document.getElementById('menu'),
  menuList: document.getElementById('menuList'),
  partsCard: document.getElementById('partsCard'),
  partsDelivery: document.getElementById('partsDelivery'),
  partsMarket: document.getElementById('partsMarket'),
  settingsCard: document.getElementById('settingsCard'),
};
